
/* injects from baggage-loader */

'use strict';

const indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

const moduleSectionDD = angular.module('services.layoutEditor.sectionDragDrop', ['services.editorNamespace', 'services.layoutEditor.insertSpace']);

moduleSectionDD.factory('sectionDragDrop', [
  '$timeout', '$injector', 'ns', 'insertSpace', 'blockDragScroll', 'Animation', 'TimeMachine',
  ($timeout, $injector, ns, insertSpace, blockDragScroll, Animation, TimeMachine) => {
    let Y;

    const sectionDD = {
      setYUI: function(y) {
        Y = y;
      },
      setEvents: function(dd, y) {
        Y = y;
        dd.before('drag:start', this._beforeDragStart, this);
        dd.on('drag:drophit', this._onDropHit, this);
        dd.on('drag:start', this._onDragStart, this);
        dd.on('drag:drag', this._onDragDrag, this);
        dd.on('drag:end', this._onDragEnd, this);
        dd.on('drag:over', this._onDragOver, this);
        dd.after('drag:end', this._afterDragEnd, this);
      },

      _beforeDragStart: function() {
        Y.DD.DDM.syncActiveShims();
      },

      _onDragStart: function(e) {
        var drag, fromMenu, originalEl;

        drag = e.target;
        originalEl = drag.get('node');
        this.clone = drag.get('dragNode');
        fromMenu = originalEl.hasClass('etnr-item__link');

        if (!fromMenu) {
          this.clone.addClass(ns.sectionDraggingClass);
        }

        if (!fromMenu) {
          this.clone.setStyles({
            zIndex: 400
          });
        }

        if (!fromMenu) {
          return originalEl.setStyles({
            display: 'none'
          });
        }
      },

      _onDragDrag: function(e) {
        e.preventDefault();
        this.clone.setStyles({
          top: e.pageY,
          left: e.pageX
        });
        return blockDragScroll.scroll(e);
      },

      _onDropHit: function(e) {
        let indexPosition = 0;

        // const layoutEditor = $injector.get('layoutEditor');
        const originalEl = e.target.get('node');
        const drop = e.drop.get('node');
        const drag = e.drag.get('node');
        const availableTags = ['header', 'section', 'footer'];
        const tagName = drop.get('tagName').toLowerCase();
        const ref = drop.get('tagName').toLowerCase();

        if (indexOf.call(availableTags, ref) >= 0) {
          if (this.nearestEdge.quad.y === 'top' && tagName === 'header') {
            return false;
          }
          if (this.nearestEdge.quad.y === 'bottom' && tagName === 'footer') {
            return false;
          }

          let previousSectionId;
          if (originalEl.previous(ns.sectionClass)) {
            previousSectionId = originalEl.previous(ns.sectionClass).getData("section-id");
          } else {
            previousSectionId = "drop-backdrop";
          }

          const originalElId = originalEl.getData("section-id");
          const dropId = drop.getData("section-id");

          switch (this.nearestEdge.quad.y) {
            case 'top':
              TimeMachine.capture("moveSection", originalElId, {
                drop: dropId,
                y: 'before'
              }, previousSectionId);

              drop.insert(drag, 'before');
              indexPosition = $(drop._node).index() - 1;
              break;
            case 'bottom':
              TimeMachine.capture('moveSection', originalElId, {
                drop: dropId,
                y: 'after'
              }, previousSectionId);

              drop.insert(drag, 'after');
              indexPosition = $(drop._node).index() + 1;
              break;
          }
        }
      },

      _onDragEnd: function(e) {
        const drag = e.target;
        const originalEl = drag.get('node');

        originalEl.setStyles({
          display: 'inherit'
        });

        insertSpace.hide();
        Animation.scrollTo($(originalEl._node));
      },

      _afterDragEnd: function() {
        // const layoutEditor = $injector.get('layoutEditor');
      },

      _onDragOver: function() {
        const blockDragDrop = $injector.get('blockDragDrop');
        const activeDropElement = Y.DD.DDM.activeDrop.get('node');

        if (activeDropElement.hasClass(ns.sectionClass.substr(1))) {
          this.nearestEdge = blockDragDrop.getDropInfo(Y);
          insertSpace.alignInsertSpaceRowOrSection(this.nearestEdge, 'section');
        }
      }
    };

    return sectionDD;
  }
]);




// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/sectionDragDrop.js